import { render, staticRenderFns } from "./systemnotifi.vue?vue&type=template&id=a752c2a6&scoped=true"
import script from "./systemnotifi.vue?vue&type=script&lang=js"
export * from "./systemnotifi.vue?vue&type=script&lang=js"
import style0 from "./systemnotifi.vue?vue&type=style&index=0&id=a752c2a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a752c2a6",
  null
  
)

export default component.exports